import { TerminatedTaskStatus, isSuccessTerminated } from '~/constants/task-status'
import { AgentTaskStatus, CommandType } from '~/protos/agents'
import { useConversationMetadata } from '../conversation'
import { useIsInternalUploadedIndex, useIsLocalSyncIndex } from '../organization'
import { useIsS3Task } from './useS3Task'
import { useTaskStatus } from './useTaskStatus'

export function useTerminatedStatus(taskStatus?: AgentTaskStatus) {
  const statusToBeUsed = taskStatus != null ? taskStatus : useTaskStatus()
  const isS3Task = useIsS3Task()
  const isInternalUploadedIndex = useIsInternalUploadedIndex()
  const isLocalSyncIndex = useIsLocalSyncIndex()
  const { command } = useConversationMetadata()
  const isLocalTask =
    isS3Task ||
    isInternalUploadedIndex ||
    isLocalSyncIndex ||
    command === CommandType.MULESOFT_TO_CAMEL_MIGRATION

  const isLocalTaskTerminated = isLocalTask && statusToBeUsed === AgentTaskStatus.DIFF_GENERATED
  const hasSuccessTerminated = isSuccessTerminated(statusToBeUsed)

  if (isLocalTaskTerminated || hasSuccessTerminated) {
    return true
  }
  return TerminatedTaskStatus.includes(statusToBeUsed)
}
